var getNative=require("./_getNative"),root=require("./_root"),DataView=getNative(root,"DataView");module.exports=DataView;